<template>
  <b-overlay :show="filmBusy">
    <error :errors="filmError" />
    <portlet title="فىلىم ئۇچۇرى تەھرىرلەش">
      <template v-slot:body>
        <film-form
          action="edit"
          ref="film"
          :model-id="modelId"
          @loading="onLoading"
          @loaded="onLoaded"
          @updating="onLoading"
          @updated="onUpdated"
        />
      </template>
      <template v-slot:foot>
        <b-button id="submit" @click="handleSubmit" variant="primary">
          ساقلاش
        </b-button>
        <b-button @click="onClickReset" class="ml-2" variant="danger">
          بىكار قىلىش
        </b-button>
      </template>
    </portlet>
  </b-overlay>
</template>

<script>
  import Portlet from "@v@/partials/content/Portlet";
  import FilmForm from "@v@/components/forms/FilmForm";
  import Error from "@v@/partials/widgets/Error";
  import BreadCrumbs from "@c@/breadcrumbs.service";
  import formBusyMixin from "@m@/common/formBusy.mixin";
  import { debugConsole } from "@c@/helpers/helpers";
  import sweetAlertMixin from "@m@/common/sweetAlert.mixin";
  import { mapGetters } from 'vuex';
  export default {
    name: "index",
    components: {Error, Portlet, FilmForm },
    mixins: [ formBusyMixin, sweetAlertMixin ],
    computed: {
      modelId(){
        if ( this.$route.hasOwnProperty('params') )
          return this.$route.params.id;
      },
      ...mapGetters(['filmError'])
    },
    mounted() {
      BreadCrumbs.setBreadCrumb([]);
      BreadCrumbs.addBreadCrumb({title: 'فىلىم باشقۇرۇش', route: {name: 'film.home'}});
      BreadCrumbs.addBreadCrumb({title: 'فىلىم ئۇچۇرى تەھرىرلەش'});
      if ( this.$refs.hasOwnProperty('film') ){
        this.form = this.$refs['film'];
      }
    },
    data(){
      return {
        filmBusy: false,
        form: {}
      };
    },
    methods: {
      handleSubmit(){
        this.form.onSubmit();
      },
      onLoading(){
        this.showBusy('filmBusy');
        debugConsole({prefix: 'film', message: 'onLoading'})
      },
      onLoaded({response, state}){
        this.hideBusy('filmBusy');
        debugConsole({prefix: 'film', message: `onLoaded: ${state}`});
      },
      onUpdated({response, state}){
        this.hideBusy('filmBusy');
        debugConsole({prefix: 'film', message: `onUpdated: ${state}`});
        if ( state === 'success' ){
          this.success({ message: 'فىلىم ئۇچۇرى تەھرىرلەش مۇۋاپىقىيەتلىك بولدى.' });
        }
      },
      onClickReset(){
        this.$router.replace({name: 'film.home'});
      },
    }
  }
</script>

<style scoped>

</style>
